import * as React from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

import { Button } from "src/library/components/Button";
import { LoadingSpinner } from "src/library/components/LoadingSpinner";
import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal/BasicModal";
import { Text } from "src/library/components/Text";
import { ErrorNotice } from "src/core/shared/components/ErrorNotice";
import PriceListDropdown from "src/core/prices/components/PriceListDropdown";
import {
  usePricesApi,
  PricesRequestName
} from "src/core/prices/api/prices.api";

export const PriceExportModal: React.ReactFCWithChildren<Pick<BasicModalProps, "onDismiss" | "open"> > = ({ onDismiss, open }) => {
  const [ exportPriceListResponse, exportPriceList ] = usePricesApi(PricesRequestName.EXPORT_PRICE_CODE);
  const [ priceCodeToExport, setPriceCodeToExport ] = React.useState<number | null>(0);

  React.useEffect(() => {
    if (exportPriceListResponse.data) {
      toast.success(exportPriceListResponse.data.message);
      exportPriceListResponse.data = null;
      onDismiss();
    }
  }, [ exportPriceListResponse, onDismiss ]);

  return (
    <StyledBasicModal
      title="Export Price Code"
      open={open}
      onDismiss={() => onDismiss()}
    >
      {exportPriceListResponse.error && (
        <ErrorNotice
          message={exportPriceListResponse.error.message}
          type="error"
        />
      )}

      {exportPriceListResponse.pending ? (
        <LoadingSpinner type="circular" />
      ) : (
        <>
          <Text as="p">
            The generated export will be the display prices with the latest effective date.
          </Text>

          <PriceListDropdown
            updateSelectedPriceCode={setPriceCodeToExport}
            value={priceCodeToExport || 0}
            additionalOptions={[
              {
                text: "Export all",
                value: ""
              }
            ]}
          />

          <Button
            className="submit-button"
            disabled={priceCodeToExport === 0}
            onClick={() => {
              if (priceCodeToExport || priceCodeToExport === null) {
                exportPriceList({ priceCodeId: priceCodeToExport });
              } else {
                // should never happen. Ensuring priceCodeId is set above before making request
                toast.error("Invalid Price Code Id");
              }
            }}
          >
            Export
          </Button>
        </>
      )}
    </StyledBasicModal>
  );
};

const StyledBasicModal = styled(BasicModal)`
  .submit-button {
    margin-top: ${({ theme }) => theme.spacing.margins.md};
  }
`;
